export default __webpack_public_path__ + "static/media/pic4.28ea761e.jpg";